import { useState, useRef } from 'react';
import { useParams, useNavigate} from 'react-router-dom';
import { useForm, Controller } from 'react-hook-form';
import DatosCabezaFamilia from '../DatosCabezaFamilia.jsx';
import apiService from '../../../Auth/apiService.jsx';
import SweetAlert2 from 'react-sweetalert2';
import 'react-datepicker/dist/react-datepicker.css';
import MenuCaracterizacion from '../Componentes/MenuCaracterizacion.jsx';
import { useAuth } from '../../../Auth/AuthContext.jsx';
import SearchForm from '../../Utils/Searchform.jsx';
import SeccionPageHeader from '../../Utils/SeccionPageHeader.jsx';
import CargandoSpinner from '../../Utils/CargandoSpinner.jsx';
import { useAtencionForm, CustomInput } from './common/AtencionShared.jsx';

import DatePicker from 'react-datepicker';
import { Card } from 'react-bootstrap';

export default function AtencionPsicosocial(){
    const navigate = useNavigate();
    const { token, user, rol, sedeActual } = useAuth();
    const { idCabezaFamilia, idDerivacion } = useParams();
    const { control, handleSubmit, register, setError, clearErrors, setValue, reset, formState: { errors }} = useForm(
        {
            defaultValues: {
                ate_detallederivacionid: idDerivacion || '0', // use '0' as default if idDerivacion is undefined
            }

        }
    );
    const [hideGuardar, setHideGuardar] = useState(false);
    const fileInputRef = useRef(null);
    
    const {
        Cargando,
        swalProps,
        setSwalProps,
        Mensaje,
        entidades,
        ayudas,
        integrantes,
        sedes,
        CabezaFamiliaDatos,
        resetForm,
    } = useAtencionForm({ token, idCabezaFamilia, rol, user, sedeActual, setValue, reset, fetchUrl: '/reparacion/crearformulariopsicosocial' });
    const [searchTerm, setSearchTerm] = useState('');
    
    const handleSearch = (event) => {
        event.preventDefault();
        if (searchTerm.trim() !== '') {
            navigate(`/caracterizacion/psicosocial/${searchTerm}/${idDerivacion}`, { replace: true });
        }
    };
    const onSubmit = async (data) => {
        if (integrantes.find((item) => item.per_idpersona === data.idpersona)?.per_fallecido === 'SI') {
            Mensaje('Registrar atencion', "No se puede registrar atencion a un integrante fallecido");
            return;
        }
        setHideGuardar(true);
        // normalize fecha to yyyy-MM-dd string
        if (data.fecha instanceof Date) {
            const d = data.fecha;
            const y = d.getFullYear();
            const m = String(d.getMonth() + 1).padStart(2, '0');
            const day = String(d.getDate()).padStart(2, '0');
            data.fecha = `${y}-${m}-${day}`;
        }
        let url;
        url = '/reparacion/registraratencionpsicosocial';
        try {
            const fileNameValue = data.act_filename || '';
            if (fileNameValue) {
                const nameOnly = fileNameValue.replace(/\.[^/.]+$/, '');
                const validName = /^[A-Za-z0-9]+$/.test(nameOnly) && nameOnly.length <= 40;
                if (!validName) {
                    Mensaje('Registrar atencion', 'El nombre del archivo debe tener máximo 40 caracteres, solo letras y números y sin espacios, no se subira el archivo');
                    return;
                }
            }
            // validate file size if a raw File object exists
            const fileObj = data.act_file_obj;
            if (fileObj instanceof File) {
                const MAX_BYTES = 5 * 1024 * 1024;
                if (fileObj.size > MAX_BYTES) {
                    setValue('act_file', null, { shouldValidate: true, shouldDirty: true });
                    setValue('act_filename', '', { shouldValidate: false });
                    setValue('act_file_obj', null, { shouldValidate: false });
                    setError('act_file', { type: 'size', message: 'El archivo excede el tamaño máximo de 5 MB' });
                    return;
                }
            }
            // ensure act_file is a base64 string (set in file onChange)
            // remove file object placeholder before sending JSON
            const payload = { ...data };
            if (payload.act_file_obj) delete payload.act_file_obj;
            const response = await apiService.post(url, payload, token);
            if (response.status === 200) {
                Mensaje('Registrar atenci&oacute;n', JSON.stringify(response.data));
            }
        } catch (error) {
            if(error.status === 422){
                Mensaje('Registrar atencion', JSON.stringify(error.response.data.errors));
            }else if(error.status === 409){
                Mensaje('Registrar atencion', JSON.stringify(error.response.data));
            }
            console.error('Error fetching data:', error);
        } finally {
            setHideGuardar(false);
            resetForm();
            // clear file fields and input element on reset
            setValue('act_file', null, { shouldValidate: false, shouldDirty: false });
            setValue('act_filename', '', { shouldValidate: false, shouldDirty: false });
            setValue('act_file_obj', null, { shouldValidate: false, shouldDirty: false });
            if (fileInputRef.current) fileInputRef.current.value = '';
        }
    };
    return (
        <div className="content-wrapper">
            <SeccionPageHeader title="Registrar atenci&oacute;n psicosocial" idCabezaFamilia={idCabezaFamilia} url={`/caracterizacion/grupofamiliar/${idCabezaFamilia}`} nombreurl="Grupo familiar" nombreform="Registrar atencion" />
            <CargandoSpinner Cargando={Cargando} />
            <section className="content">
                <div className="container-fluid">
                    <MenuCaracterizacion idCabezaFamilia={idCabezaFamilia} />
                    <SearchForm searchTerm={searchTerm} setSearchTerm={setSearchTerm} handleSearch={handleSearch} Cargando={Cargando} />
                    <Card>
                        <div className="d-flex justify-content-end">
                            <button
                                type="button"
                                className="btn btn-secondary"
                                onClick={() => navigate('/caracterizacion/listaratencionpsicosocial/' + idCabezaFamilia)}
                            >
                                Ver atenciones psicosociales
                            </button>
                        </div>
                    </Card>
                    <div className="row">
                        <div className="col-md-12">
                            <div className="card card-info">
                            <form className="form-horizontal" onSubmit={handleSubmit(onSubmit)}>
                                <div className="card-body">
                                <DatosCabezaFamilia datos={CabezaFamiliaDatos} />
                                <input hidden {...register('usrId')}/>
                                <input hidden {...register('cabIdcabezafamilia')}/>
                                <input hidden {...register('ate_detallederivacionid')}/>
                                <div className="row">
                                    <div className="col-md-4">
                                        <div className="form-group" >
                                            <label htmlFor='entidad'>Entidad:</label>
                                            <select id='entidad' {...register('entidad', { required: true })} className='form-control' >
                                                {entidades.map((option) => (
                                                <option key={option.id} value={option.id}>
                                                {option.entEntidad}
                                                </option>
                                                ))}
                                            </select>
                                            {errors.entidad && <p style={{color: 'red'}}>Seleccione entidad</p>}
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="form-group" >
                                            <label htmlFor='ayuda'>Atenci&oacute;n:</label>
                                            <select id='ayuda' {...register('ayuda', { required: true })} className='form-control' >
                                                <option value="">Seleccionar</option>
                                                {ayudas.map((option) => (
                                                <option key={option.id} value={option.id}>
                                                    {option.ayuAyuda}
                                                </option>
                                                ))}
                                            </select>
                                            {errors.ayuda && <p style={{color: 'red'}}>Seleccione atencion</p>}
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="form-group" >
                                            <label htmlFor='idpersona'>Integrante:</label>
                                            <select id='idpersona' {...register('idpersona', { required: true })} className='form-control' >
                                                {integrantes.map((option) => (
                                                <option key={option.per_idpersona} value={option.per_idpersona}>
                                                    {option.par_parentesco} {option.per_idpersona} {option.nombre} {option.per_fallecido === 'SI' ? '(Fallecido)' : ''}
                                                </option>
                                                ))}
                                            </select>
                                            {errors.idpersona && <p style={{color: 'red'}}>Seleccione integrante</p>}
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-4">
                                        <div className="form-group">
                                            <label htmlFor='fecha'>Fecha atenci&oacute;n</label>
                                            <Controller
                                                id="fecha"
                                                control={control}
                                                name="fecha"
                                                render={({ field }) => (
                                                    <DatePicker
                                                        placeholderText="fecha"
                                                        onChange={(date) => field.onChange(date)}
                                                        showMonthDropdown
                                                        showYearDropdown
                                                        dropdownMode="select"
                                                        selected={field.value}
                                                        customInput={<CustomInput />}
                                                        locale="es"
                                                        dateFormat="yyyy-MM-dd"
                                                        maxDate={new Date()}
                                                    />
                                                )}
                                            />
                                            {errors.fecha && <p style={{color: 'red'}}>Digite fecha de atencion</p>}
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="form-group" >
                                            <label htmlFor='cantidad'>Cantidad</label>
                                            <input id='cantidad' className="form-control" 
                                                {...register('cantidad', { required: true })}
                                                placeholder="cantidad"/>
                                            {errors.cantidad && <p style={{color: 'red'}}>Digite cantidad</p>}
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-4">
                                        <div className="form-group" >
                                            <label htmlFor='sede'>Sede:</label>
                                            <select id='sede' {...register('sede', { required: true })} className='form-control'>
                                                {sedes.map((option) => (
                                                <option key={option.id} value={option.id}>
                                                    {option.sedNombre}
                                                </option>
                                                ))}
                                            </select>
                                            {errors.sede && <p style={{color: 'red'}}>Seleccione sede</p>}
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className='row'>
                                            <div className="col-md-12">
                                                <label htmlFor="observaciones">Observaciones</label>
                                            </div>
                                        </div>
                                        <div className='row'>
                                            <div className="col-md-12">
                                            <textarea rows={3} style={{ width: '100%' }}
                                                {...register('observaciones', { required: true })}
                                                placeholder="observaciones"
                                            />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className='row'>
                                            <div className="col-md-12">
                                                <label htmlFor="observacionDos">Atenci&oacute;n Psicosocial</label>
                                            </div>
                                        </div>
                                        <div className='row'>
                                            <div className="col-md-12">
                                            <textarea rows={5} style={{ width: '100%' }}
                                                {...register('observacionDos')}
                                                placeholder="observaciones psicosocial"
                                            />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-4">
                                        <div className="form-group" >
                                            <label htmlFor='ate_atencioncerrada'>Esta persona necesita una nueva atenci&oacute;n?</label>
                                            <select id='ate_atencioncerrada' {...register('ate_atencioncerrada')} className='form-control' >
                                                <option value="">Seleccionar</option>
                                                <option value="SI">SI (Abierta)</option>
                                                <option value="NO">NO (Cerrada)</option>
                                            </select>
                                            {errors.ate_atencioncerrada && <p style={{color: 'red'}}>Seleccione atencion</p>}
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="row">
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label htmlFor="act_file">Subir archivo PDF</label>
                                                <input
                                                    type="file"
                                                    accept="application/pdf"
                                                    className="form-control"
                                                    multiple={false}
                                                    ref={fileInputRef}
                                                    onChange={(e) => {
                                                        const f = e.target.files?.[0];
                                                        // reset previous errors/values
                                                        clearErrors(['act_file', 'act_filename', 'act_file_obj']);
                                                        if (!f) {
                                                            setValue('act_file', null, { shouldValidate: true, shouldDirty: true });
                                                            setValue('act_filename', '', { shouldValidate: false });
                                                            setValue('act_file_obj', null, { shouldValidate: false });
                                                            return;
                                                        }
                                                        if (f.type !== 'application/pdf') {
                                                            setValue('act_file', null, { shouldValidate: true, shouldDirty: true });
                                                            setValue('act_filename', '', { shouldValidate: false });
                                                            setError('act_file', { type: 'type', message: 'Solo se permiten archivos PDF' });
                                                            return;
                                                        }
                                                        // validate filename: only letters and numbers, no spaces/special chars, max 40 chars
                                                        const nameOnly = f.name.replace(/\.[^/.]+$/, ''); // strip extension
                                                        const validName = /^[A-Za-z0-9]+$/.test(nameOnly) && nameOnly.length <= 40;
                                                        if (!validName) {
                                                            setValue('act_file', null, { shouldValidate: true, shouldDirty: true });
                                                            setValue('act_filename', '', { shouldValidate: false });
                                                            setError('act_filename', { type: 'pattern', message: 'El nombre del archivo debe tener máximo 40 caracteres, solo letras y números y sin espacios. No se subirá el archivo' });
                                                            return;
                                                        }
                                                        const reader = new FileReader();
                                                        reader.onload = (ev) => {
                                                            const dataUrl = ev.target?.result || '';
                                                            if (typeof dataUrl !== 'string' || !dataUrl.includes(',')) {
                                                                setValue('act_file', null, { shouldValidate: true, shouldDirty: true });
                                                                setValue('act_filename', '', { shouldValidate: false });
                                                                setValue('act_file_obj', null, { shouldValidate: false });
                                                                return;
                                                            }
                                                            const base64 = dataUrl.split(',')[1] || '';
                                                            setValue('act_file', base64, { shouldValidate: true, shouldDirty: true });
                                                            // store only the validated name (keep extension if needed)
                                                            setValue('act_filename', f.name, { shouldValidate: false, shouldDirty: false });
                                                            // also store the raw file object for multipart submissions
                                                            setValue('act_file_obj', f, { shouldValidate: false, shouldDirty: true });
                                                        };
                                                        reader.onerror = () => {
                                                            setValue('act_file', null, { shouldValidate: true, shouldDirty: true });
                                                            setValue('act_filename', '', { shouldValidate: false });
                                                            setValue('act_file_obj', null, { shouldValidate: false });
                                                        };
                                                        reader.readAsDataURL(f);
                                                    }}
                                                    aria-label="Seleccionar archivo (PDF)"
                                                />
                                                <input type="hidden" {...register('act_file')} />
                                                {errors.act_file && <p style={{ color: 'red' }}>{errors.act_file.message || 'Ingrese archivo'}</p>}
                                                <input type="hidden" {...register('act_filename')} />
                                                {errors.act_filename && <p style={{ color: 'red' }}>{errors.act_filename.message || 'Nombre de archivo inválido'}</p>}
                                                <input type="hidden" {...register('act_file_obj')} />
                                                {errors.act_file_obj && <p style={{ color: 'red' }}>{errors.act_file_obj.message || 'Ingrese archivo'}</p>}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    
                                    <div className="col-md-2">
                                        {!hideGuardar &&
                                            <button type="submit" className="btn btn-primary">Guardar</button>
                                        }
                                        {hideGuardar &&
                                            <button type="button" className="btn btn-primary" disabled>Guardando...</button>
                                        }
                                    </div>
                                </div>
                                </div>
                            </form>
                        </div>
                        {/* /.card */}

                        </div>
                        {/*/.col (left) */}

                    </div>
                    {/* /.row */}
                </div>{/* /.container-fluid */}
                <SweetAlert2 {...swalProps} 
                didClose={() => {
                    setSwalProps({})
                }}/>
            </section>
        </div>
    );
}